import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as React from 'react';
import { memo, useMemo } from 'react';
import { Box, Typography, useTheme } from '@mui/material';
import { isIntervalsHorizontal } from '../utils';
export const RangeTimeLine = memo(function RangeTimeLine(props) {
    const { labels, intervals_direction } = props;
    const theme = useTheme();
    const backgroundColor = useMemo(() => {
        return theme.palette.primary.main;
    }, [theme]);
    const labels_marks = useMemo(() => labels.map(({ offset, label }) => (_jsx(RangeMarkUp, { intervals_direction: intervals_direction, offset: offset, label: label, backgroundColor: backgroundColor }, offset))), [intervals_direction, labels, backgroundColor]);
    return (_jsx(Box, { position: "absolute", width: "100%", height: "100%", children: labels_marks }));
});
export const RangeMarkUp = memo(function RangeMarkUp(props) {
    const { intervals_direction, offset, label, backgroundColor } = props;
    const { border_top, border_left, top_offset, left_offset, label_offset, height, width, line_offset, } = useMemo(() => {
        const show_border = `1px solid ${backgroundColor}`;
        const border_top = isIntervalsHorizontal(intervals_direction)
            ? undefined
            : show_border;
        const border_left = isIntervalsHorizontal(intervals_direction)
            ? show_border
            : undefined;
        const top_offset = isIntervalsHorizontal(intervals_direction)
            ? undefined
            : `${offset}%`;
        const left_offset = isIntervalsHorizontal(intervals_direction)
            ? `${offset}%`
            : undefined;
        const height = isIntervalsHorizontal(intervals_direction) ? '100%' : undefined;
        const width = isIntervalsHorizontal(intervals_direction)
            ? undefined
            : 'calc(100% - 6px)';
        const label_offset = isIntervalsHorizontal(intervals_direction)
            ? `translateX(-50%)`
            : `translateY(-40%)`;
        const line_offset = isIntervalsHorizontal(intervals_direction) ? '0px' : '18px';
        return {
            border_left,
            border_top,
            label_offset,
            top_offset,
            left_offset,
            height,
            width,
            line_offset,
        };
    }, [intervals_direction]);
    return (_jsxs(Box, { position: "absolute", height: height, width: width, top: top_offset, left: left_offset, children: [_jsx(Box, { position: "relative", height: height, width: width, borderTop: border_top, borderLeft: border_left, ml: line_offset }), _jsx(Box, { position: "relative", style: {
                    transform: label_offset,
                }, children: _jsx(Typography, { variant: "subtitle1", color: "textSecondary", display: "inline", children: label }) })] }));
});
